<template>
    <div>account</div>
</template>

<script>
    export default {
        name: 'account',
    };
</script>

<style scoped>

</style>